interface PilotOnboardingAccessParams {
    env?: string;
    organizationID?: string;
    isSystemAdmin?: boolean;
}

const PROD_ALLOWED_ORG_ID = 'QONTACT';
const QA_ALLOWED_ORG_ID = 'DEMO1';

export const isPilotOnboardingOrgEnabled = (env?: string, organizationID?: string) => {
    const normalizedEnv = (env || 'PROD').toUpperCase();
    const normalizedOrganizationID = (organizationID || '').toUpperCase();

    if (normalizedEnv === 'PROD') {
        return normalizedOrganizationID === PROD_ALLOWED_ORG_ID;
    }

    if (normalizedEnv === 'QA') {
        return normalizedOrganizationID === QA_ALLOWED_ORG_ID;
    }

    return false;
};

export const isPilotOnboardingSystemAdminEnabled = (isSystemAdmin?: boolean) => isSystemAdmin === true;

export const canAccessPilotOnboarding = ({
    env,
    organizationID,
    isSystemAdmin,
}: PilotOnboardingAccessParams) => {
    return isPilotOnboardingOrgEnabled(env, organizationID) && isPilotOnboardingSystemAdminEnabled(isSystemAdmin);
};
